/**
 * V2 onboarding cutoff date - only show V2-specific onboarding dialogs to users created before this date.
 * Users created on or after this date are considered "new" users who don't need migration explanations.
 */
export const V2_ONBOARDING_CUTOFF_DATE = new Date('2025-12-02T00:00:00Z');
